"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var IframeMessage_1 = tslib_1.__importDefault(require("./IframeMessage"));
var iframe_apis_1 = require("./iframe-apis");
var globalIhaier2Instance = undefined;
var IHaierIFrameRuntime = /** @class */ (function () {
    function IHaierIFrameRuntime() {
        this.iframeMessage = new IframeMessage_1.default(); //iframe事件交互类
        if (globalIhaier2Instance) {
            return globalIhaier2Instance;
        }
        globalIhaier2Instance = this;
        this.init();
    }
    //初始化动态创建方法
    IHaierIFrameRuntime.prototype.init = function () {
        var _this = this;
        iframe_apis_1.apis.forEach(function (api) {
            var _a;
            var apiNameList = api === null || api === void 0 ? void 0 : api.split(".");
            //@ts-ignore
            _this[apiNameList[0]] = (_a = _this[apiNameList[0]]) !== null && _a !== void 0 ? _a : {};
            if (apiNameList.length === 2) {
                //@ts-ignore
                _this[apiNameList[0]][apiNameList[1]] = _this.createApi(api);
            }
            else {
                //@ts-ignore
                _this[apiNameList[0]] = _this.createApi(api);
            }
        });
    };
    //创建api方法
    IHaierIFrameRuntime.prototype.createApi = function (api) {
        var _this = this;
        return function (options) {
            return _this.iframeMessage.sendMessage(api, options);
        };
    };
    return IHaierIFrameRuntime;
}());
exports.default = IHaierIFrameRuntime;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSUhhaWVySUZyYW1lUnVudGltZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9pZnJhbWUvSUhhaWVySUZyYW1lUnVudGltZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSwwRUFBNEM7QUFDNUMsNkNBQXFDO0FBR3JDLElBQUkscUJBQXFCLEdBQVEsU0FBUyxDQUFDO0FBQzNDO0lBRUU7UUFEUSxrQkFBYSxHQUFrQixJQUFJLHVCQUFhLEVBQUUsQ0FBQyxDQUFDLGFBQWE7UUFFdkUsSUFBSSxxQkFBcUIsRUFBRTtZQUN6QixPQUFPLHFCQUE0QixDQUFDO1NBQ3JDO1FBQ0QscUJBQXFCLEdBQUcsSUFBSSxDQUFDO1FBQzdCLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUNkLENBQUM7SUFDRCxXQUFXO0lBQ0gsa0NBQUksR0FBWjtRQUFBLGlCQWFDO1FBWkMsa0JBQUksQ0FBQyxPQUFPLENBQUMsVUFBQyxHQUFXOztZQUN2QixJQUFNLFdBQVcsR0FBYSxHQUFHLGFBQUgsR0FBRyx1QkFBSCxHQUFHLENBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1lBQzlDLFlBQVk7WUFDWixLQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQUcsS0FBSSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxtQ0FBSSxFQUFFLENBQUM7WUFDbEQsSUFBSSxXQUFXLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtnQkFDNUIsWUFBWTtnQkFDWixLQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsS0FBSSxDQUFDLFNBQVMsQ0FBQyxHQUFHLENBQUMsQ0FBQzthQUM1RDtpQkFBTTtnQkFDTCxZQUFZO2dCQUNaLEtBQUksQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFJLENBQUMsU0FBUyxDQUFDLEdBQUcsQ0FBQyxDQUFDO2FBQzVDO1FBQ0gsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBQ0QsU0FBUztJQUNELHVDQUFTLEdBQWpCLFVBQWtCLEdBQVc7UUFBN0IsaUJBSUM7UUFIQyxPQUFPLFVBQUMsT0FBc0I7WUFDNUIsT0FBTyxLQUFJLENBQUMsYUFBYSxDQUFDLFdBQVcsQ0FBQyxHQUFHLEVBQUUsT0FBTyxDQUFDLENBQUM7UUFDdEQsQ0FBQyxDQUFDO0lBQ0osQ0FBQztJQTZFSCwwQkFBQztBQUFELENBQUMsQUExR0QsSUEwR0MifQ==